// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__0tJiZ","slick-next":"CustomSlider_slick-next__BSqHb"};